import {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {UtcDateTimeToDateTime} from "../../hooks/dates";
import Icon from "../../components/icon";
import Header from "../../layouts/Header";


const Listing = () => {
    const searchColumn = 'subject'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())


    const fetchEntities = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut("/emails/get",
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };


    useEffect(() => {
        fetchEntities().then((entities) => {
            setEntities(entities);
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange]);


    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete("/emails/delete",
                {
                    data: {idx: selected}, onSuccess: (response) => {
                        setLastChange(Date.now());
                    }
                }
            );


        }
    };


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Subject", prop: "subject", size: 25, output: (entity) => {
                    return <Link to={`/emails/${entity?._id?.$oid}`}>
                        <strong>{entity?.content?.subject}</strong>
                    </Link>;
                }
            },
            {
                label: "Sender name", prop: "sender", output: (entity) => {
                    return entity?.origin?.sender_name
                }
            },
            {
                label: "Reply to", prop: "reply_to", output: (entity) => {
                    return entity?.origin?.reply_to
                }
            },
            {
                label: "Enterprise name", size: 25, prop: "enterprise", output: (entity) => {
                    return entity?.Enterprise?.name
                }
            },
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            }
        ],
        filters       : [],
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        edit          : {
            path : `/emails/:id`,
            label: "Edit email",
            icon : "edit"
        }
    };


    return (
        <>
            <Header
                icon="email"
                title="Email Manager"
                buttons={[
                    <Link to={'new'} className="btn btn-sm btn-primary">
                        <Icon name="plus"/> <span>Create</span>
                    </Link>
                ]}
            />
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Listing;